import React from "react";
import Header from "../components/Header";
import ProductContainer from "../components/ProductContainer";
import ProductInputForm from "../components/ProductInputForm";

const HomePage = () => {
  return (
    <>
      <Header />
      <main className="py-16">
        <div className="productWrapper">
          <ProductContainer />
          <ProductInputForm />
        </div>
      </main>
    </>
  );
};

export default HomePage;
